export default "__VITE_ASSET__d_hNU6ri__"